import { ITreatmentClassification, ThemeClassification } from 'types';

import { Box, Stack, Typography } from '@mui/material';

export const RiskClassificationLegend: React.FC = () => {
  return (
    <Stack
      mt={4}
      gap="8px"
      spacing={2}
      direction="row"
      justifyContent="flex-end"
    >
      {Object.keys(ThemeClassification).map((key, index) => {
        return (
          <Stack direction="row" spacing={1} alignItems="baseline" key={index}>
            <Box
              key={index}
              borderRadius={1}
              display="flex"
              sx={{
                width: 12,
                height: 12,
                backgroundColor:
                  ThemeClassification[key as ITreatmentClassification].color,
              }}
            />
            <Typography
              mb={1}
              color="#6F727A"
              fontWeight={700}
              sx={{ fontSize: 14, textTransform: 'uppercase' }}
            >
              {ThemeClassification[key as ITreatmentClassification].title}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};

